import './App.css'
import React from 'react';
import SweetyTokenPage from './components/SweetyTokenPage';

function App() {
  return (
    <>
      <SweetyTokenPage />
    </>
  )
}

export default App